import { render, staticRenderFns } from "./SuperusersDropdown.vue?vue&type=template&id=4b112df6&"
import script from "./SuperusersDropdown.vue?vue&type=script&lang=js&"
export * from "./SuperusersDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports